import {
  ErrorResponse,
  isErrorResponse,
  isRegistrationResponse,
  isVerificationResponse,
  registerUser,
  RegistrationResponse,
  VerificationResponse,
  verifyUser,
} from '@firstlookmedia/newsletter';

import { dispatchEventToParent, isMessageFromParent } from './messaging';

const registerEventName = 'user:register';
const verifyEventName = 'user:verify';

const getRegisterResponse = async (
  event: MessageEvent,
): Promise<ErrorResponse | RegistrationResponse | null> => {
  if (!(await isMessageFromParent(event))) {
    return null;
  }

  if (typeof event.data !== 'object' || typeof event.data.piano !== 'object') {
    return null;
  }

  const response = event.data.piano;
  if (!isErrorResponse(response) && !isRegistrationResponse(response)) {
    return null;
  }

  return response;
};

const getVerifyResponse = async (
  event: MessageEvent,
): Promise<ErrorResponse | VerificationResponse | null> => {
  if (!(await isMessageFromParent(event))) {
    return null;
  }

  if (typeof event.data !== 'object' || typeof event.data.piano !== 'object') {
    return null;
  }

  const response = event.data.piano;
  if (!isErrorResponse(response) && !isVerificationResponse(response)) {
    return null;
  }

  return response;
};

export const register: typeof registerUser = (
  request,
  { serviceOrigin } = {},
) =>
  new Promise((resolve, reject) => {
    dispatchEventToParent(registerEventName, { ...request, serviceOrigin });

    const handleMessage = async (event: MessageEvent) => {
      const response = await getRegisterResponse(event);
      if (!response) {
        return;
      }

      window.removeEventListener('message', handleMessage);

      if (response.status === 'error') {
        reject(new Error(response.message));
      } else {
        resolve(response);
      }
    };

    window.addEventListener('message', handleMessage, false);
  });

export const verify: typeof verifyUser = (request, { serviceOrigin } = {}) =>
  new Promise((resolve, reject) => {
    dispatchEventToParent(verifyEventName, { ...request, serviceOrigin });

    const handleMessage = async (event: MessageEvent) => {
      const response = await getVerifyResponse(event);
      if (!response) {
        return;
      }

      window.removeEventListener('message', handleMessage);

      if (response.status === 'error') {
        reject(new Error(response.message));
      } else {
        resolve(response);
      }
    };

    window.addEventListener('message', handleMessage, false);
  });
